module.exports = __webpack_public_path__ + "img/icon-manage-your-event.558de11c.png";